import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

/**
 * @member [reportCategoryService]  reportCategoryService
 */
var reportCategoryService;

/**
 * Object report Category, manages categories reports
 * @module services/reportCategoryService
 * @returns [reportCategoryService]
 */

export default function () { // lazy initialization. we export function which returns servies. this way service will be created only when it will be really necessary

	/**
	* Assigns ReportCategory class with properties
	* @member [ReportCategory] ReportCategory
	*/
	var ReportCategoryModel = Model.extend({
		className: "superCategory",
		defaults: {
			'manualTitle': false,
		},
		/**
		* @Todo this funciton is also on the report model... bad practice to have 2 times the same fucntion. should be actually only ghere.
		* @function checkIconType
		* @returns [IconType 'SVG' or 'ion']
		* @memberOf ReportCategoryModel
		*/
		checkIconType: function () {
			var thisReportType = '';
			var reportIconRaw = this.attributes.icon;
			if (reportIconRaw.substring(2, 5) == 'xml') {
				// SVG icon
				thisReportType = 'SVG';
			}
			else if (reportIconRaw.substring(0, 3) == 'ion') {
				// ion icon.
				thisReportType = 'ion';
			}
			this._type = thisReportType;
			return thisReportType;
		}, // end checkIconType

		getIcon: function(){
			return this.attributes.imageIconP;
		}
	});

	/**
	* Represents a collection of ReportCategories
	* @member [ReportCategory collection] ReportCategoryCollection
	*/

	var ReportCategoryCollection = Collection.extend({
		model: ReportCategoryModel
	});

	/**
	* it's ReportCategory service, object type service of the collection
	* @member [ReportCategory Service] ReportCategoryService
	*/
	var ReportCategoryService = ParseService.extend({
		sortBy: 'createdAt',
		order: 'dsc',
		model: ReportCategoryModel,
		collection: ReportCategoryCollection,

		setNewCategory:function(name, prefijo, file, listUsers){
			var NewCategory = Parse.Object.extend("superCategory");
			var newsupcategory = new NewCategory();
			newsupcategory.set("name",name);
			newsupcategory.set("prefijo",prefijo);
			newsupcategory.set("iconFile",file);
			newsupcategory.set("active", true);
			for(var i = 0; i < listUsers.length; ++i){
				var newRelation = newsupcategory.relation("collaborators");
				newRelation.add(listUsers[i]);
			}
			newsupcategory.save(null, {
				success: function(newsupcategory) {
					toastr.success('Nueva Categoría Agregada.',"Operación realizada");
				},
				error: function(newsupcategory, error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error(arrlang[lang]['NewSuperCategoryError'],"Error");
						break;
					}
				}
			});
		},

		updateCategory:function(cateid, name, prefijo, file){
			var category = Parse.Object.extend("superCategory");
			var query = new Parse.Query(category);
			query.equalTo("objectId", cateid);
			query.first({
				success: function(object) {
					object.set("name",name);
					object.set("prefijo",prefijo);
					object.set("iconFile",file);
					object.save();
					toastr.success("Categoría Actualizada Correctamente","Operación realizada");
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error(arrlang[lang]['SuperCategoryUpdateError'],"Error");
						break;
					}
				}
			});
		},

		updateSubCategory:function(subcateid, name, xl){
			var subcategory = Parse.Object.extend("subCategory");
			var query = new Parse.Query(subcategory);
			query.equalTo("objectId", subcateid);
			query.first({
				success: function(object) {
					object.set("name",name);
					object.save().then(subCat => {
						xl(subCat);
					},
					error => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		},

		setNewAdminCateg:function(cateid, userid){
			var category = Parse.Object.extend("superCategory");
			var query = new Parse.Query(category);
			query.equalTo("objectId", cateid);
			query.first({
				success: function(object) {
					object.set("userincharge", userid);
					object.save().then(subCat => {
						toastr.success("Usuario Asignado Correctamente", "Operación realizada");
					},
					error => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		},

		setNewAdminSubCateg:function(subcateid, userid){
			var category = Parse.Object.extend("subCategory");
			var query = new Parse.Query(category);
			query.equalTo("objectId", subcateid);
			query.first({
				success: function(object) {
					object.set("userincharge", userid);
					object.save().then(subCat => {
						toastr.success("Usuario Asignado Correctamente", "Operación realizada");
					},
					error => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		}
		// you can also extend any method from ParseService here
	});

	return reportCategoryService || (reportCategoryService = new ReportCategoryService());
};
// only created once for application
